import { Button } from 'reactstrap';
import { StageTuple } from '..';
import React from 'react';
import { PlanTemplate } from '../../../../../../../../entities/v1/applicant_tracking/PlanTemplate';

function convertOptionsToMapping(
  mapping: Map<number, StageTuple>,
): Map<number, number> {
  const newMap = new Map<number, number>();

  mapping.forEach((v: StageTuple, k: number) => {
    newMap.set(k, v.id);
  });

  return newMap;
}

export function Footer(props: {
  disabled: boolean;
  mapping: Map<number, StageTuple>;
  oldWorflow: PlanTemplate;
  onClose: (success: boolean, mappedWorkflow?: Map<number, number>) => void;
}) {
  return (
    <>
      <span className='text-dark-200 fs-5'>
        No changes will be applied until the job is saved.
      </span>
      <div className='d-flex gap-3'>
        <Button color='danger' onClick={() => props.onClose(false)}>
          Cancel
        </Button>
        <Button
          color='primary'
          disabled={props.disabled}
          onClick={() =>
            props.onClose(true, convertOptionsToMapping(props.mapping))
          }
        >
          Change Workflow
        </Button>
      </div>
    </>
  );
}
